import { colors } from 'styles/colors';

type Props = {
  className?: string;
};

export const FoodsIcon: React.FC<Props> = ({ className = 'w-5 h-5' }) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.3477 4.55566L0.934323 17.0001"
        stroke={colors.pink500}
        strokeWidth="1.06667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.27901 15.2222C9.28196 15.2222 10.9057 13.6303 10.9057 11.6666C10.9057 9.70296 9.28196 8.11108 7.27901 8.11108C5.27606 8.11108 3.65234 9.70296 3.65234 11.6666C3.65234 13.6303 5.27606 15.2222 7.27901 15.2222Z"
        fill="white"
        stroke={colors.gray900}
        strokeWidth="1.06667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8122 11.6668C13.8152 11.6668 15.4389 10.0749 15.4389 8.11122C15.4389 6.14754 13.8152 4.55566 11.8122 4.55566C9.80926 4.55566 8.18555 6.14754 8.18555 8.11122C8.18555 10.0749 9.80926 11.6668 11.8122 11.6668Z"
        fill="white"
        stroke={colors.gray900}
        strokeWidth="1.06667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4411 8.11111C17.4441 8.11111 19.0678 6.51924 19.0678 4.55556C19.0678 2.59188 17.4441 1 15.4411 1C13.4382 1 11.8145 2.59188 11.8145 4.55556C11.8145 6.51924 13.4382 8.11111 15.4411 8.11111Z"
        fill="white"
        stroke={colors.gray900}
        strokeWidth="1.06667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
